<template>
  <div class="hm-table">
    <slot name="no-data" v-if="isNoData"></slot>
    <slot :data="{ items }" v-if="!isNoData && tableData">
      <div class="d-flex table-wrap">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" v-for="field in fields" :key="field.name">
                {{ field.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(rowData, rowIndex) in tableData"
              :key="rowIndex"
              @click="$emit('item-click')"
              :class="{
                'is-hover': hoverIndex === rowIndex,
              }"
            >
              <td
                @click="
                  $event => cellData.disableClick && $event.stopPropagation()
                "
                @mouseenter="setHoverIndex(rowIndex, cellData)"
                @mouseleave="hoverIndex = null"
                :class="getCssClass(cellData)"
                v-for="(cellData, cellIndex) in rowData"
                :key="cellIndex"
              >
                <slot :name="cellData.slotName" :data="cellData.slotData">
                  {{ cellData.text }}
                </slot>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- <div class="table-right-spacer"></div> -->
      </div>
    </slot>
  </div>
</template>

<script lang="ts">
import { get } from 'lodash-es';

interface Field {
  name?: string;
  title?: string;
  key?: string;
  cssClass?: string;
  disableClick?: boolean;
}

export default {
  props: {
    fields: {
      type: Array as () => Array<Field>,
      default() {
        return [];
      },
    },
    items: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      hoverIndex: null,
    };
  },
  computed: {
    tableData() {
      if (!this.items) return;

      const tableData = this.items.map(result => {
        return this.fields.map((field, fieldIndex) => {
          return {
            cssClass: field.cssClass || '',
            slotData: result,
            slotName: field.name || fieldIndex,
            text: field.key ? get(result, field.key) : null,
            disableClick: field.disableClick,
          };
        });
      });

      return tableData;
    },
    isNoData() {
      return this.tableData && !this.tableData.length;
    },
  },
  methods: {
    getCssClass(cellData) {
      const cssClass = cellData.cssClass?.split(' ') || '';
      if (cellData.disableClick) cssClass.push('disable-click');
      return cssClass.join(' ');
    },
    setHoverIndex(rowIndex, cellData) {
      if (!cellData.disableClick) {
        this.hoverIndex = rowIndex;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

// .table-right-spacer {
//   flex-shrink: 0;
//   width: $table-right-spacing;
// }

.table-wrap {
  overflow-x: auto;
}

tbody td {
  vertical-align: middle;
}

.is-hover {
  td:not(.disable-click) {
    background-color: $light-gray;
  }
}

.ordering--selected {
  color: $coral;
}

.cell-shrink {
  width: 0.1%;
  white-space: nowrap;
}
</style>
